import "./Footer.css"

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-branding">
          <h2 className="footer-title">Badkul Technology</h2>
          <p className="footer-subtitle">JWT Decoder Tool</p>
        </div>
        <div className="footer-copyright">© {currentYear} Badkul Technology. All rights reserved.</div>
      </div>
    </footer>
  )
}

export default Footer
